export default "__VITE_PUBLIC_ASSET__fadb231e__"